import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'semantic-ui-react';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';
import {isEmpty as _isEmpty} from 'lodash';

import {
    createExportExcelProps,
    getExcel,
    setColumnsWidth,
} from '@utils/export/excel';

import ExcelRedirect from './Export/Excel/ExcelRedirect';

export class ExcelExportButton extends React.Component {
    static propTypes = {
        exportExcelParams: PropTypes.shape({
            dataExport: PropTypes.array,
            filename: PropTypes.string,
            parseData: PropTypes.func,
            path: PropTypes.string,
            titles: PropTypes.array,
        }),
        loading: PropTypes.bool.isRequired,
        match: PropTypes.object.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
        floated: PropTypes.string,
    };

    static defaultProps = {
        exportExcelParams: {
            dataExport: [],
            filename: null,
            parseData: (row) => (row),
            path: null,
            titles: [],
        },
        floated: null,
    };

    /**
     * Check if URL and settings (eg. data for export) allow
     * download export directly by URL https://AVCMP/export/excel
     */
    canBeExportByUrl = (url) => (!this.props.loading && url === this.props.match.path);

    render() {
        const noExportParameters = (
            _isEmpty(this.props.exportExcelParams)
            || _isEmpty(this.props.exportExcelParams.filename)
        );

        if (noExportParameters) {
            return null;
        }


        const exportParameters = createExportExcelProps(this.props.exportExcelParams),
            {dataSet, filename, url} = exportParameters,
            renderElements = [];

        {dataSet.map(el => setColumnsWidth(el.data, el.columns));}

        /**
         * Export by URL: AVCMP/somepath/export/excel
         */
        if (this.canBeExportByUrl(url)) {
            getExcel(dataSet, filename);

            /**
             * Redirect from URL/somepath/export/excel to URL/somepath
             */
            renderElements.push(
                <ExcelRedirect
                    key='ExcelExportRedirect'
                    pathname={this.props.location.pathname}
                />
            );
        }

        if (!_isEmpty(this.props.exportExcelParams.dataExport)) {
            /**
             * Button for export excel
             */
            renderElements.push(
                <Button key='ExcelExportDownloadOnDemand' icon='file excel outline' content='Export' floated={this.props.floated}
                    onClick={() => getExcel(dataSet, filename)}/>
            );
        }

        return renderElements;
    }
}

export default withRouter(connect(null, null)(ExcelExportButton));
